(() => {
  if (window.IslanderFaqAccordion) {
    window.IslanderFaqAccordion.initialize(document);
    return;
  }

  const groupSelector = [
    '.islander-workshop-faq__items',
    '.islander-private-events__faq-list',
    '.islander-contact__faq-list',
    '.stores-story__faq-list',
    '.islander-support__category-content',
    '.islander-support__disclosures',
    '.collapsible-content__wrapper',
  ].join(',');

  const initializedGroups = new WeakSet();
  const activeAnimations = new WeakMap();
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function finishAnimation(item, shouldOpen) {
    item.open = shouldOpen;
    item.style.removeProperty('height');
    item.style.removeProperty('overflow');
    item.style.removeProperty('will-change');
    activeAnimations.delete(item);
  }

  function setItemOpen(item, shouldOpen, animate = true) {
    const summary = item.querySelector(':scope > summary');
    if (!summary || item.open === shouldOpen && !activeAnimations.has(item)) return;

    activeAnimations.get(item)?.cancel();

    if (!animate || reducedMotionQuery.matches || typeof item.animate !== 'function') {
      finishAnimation(item, shouldOpen);
      return;
    }

    const startHeight = item.getBoundingClientRect().height;
    if (shouldOpen) item.open = true;
    const endHeight = shouldOpen ? item.scrollHeight : summary.getBoundingClientRect().height;

    item.style.height = `${startHeight}px`;
    item.style.overflow = 'hidden';
    item.style.willChange = 'height';

    const animation = item.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      {
        duration: 260,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      },
    );
    activeAnimations.set(item, animation);

    animation.addEventListener('finish', () => finishAnimation(item, shouldOpen), { once: true });
    animation.addEventListener(
      'cancel',
      () => {
        if (activeAnimations.get(item) !== animation) return;
        item.style.removeProperty('height');
        item.style.removeProperty('overflow');
        item.style.removeProperty('will-change');
        activeAnimations.delete(item);
      },
      { once: true },
    );
  }

  function initializeGroup(group) {
    if (initializedGroups.has(group)) return;

    const items = Array.from(group.querySelectorAll('details'));
    if (items.length < 2) return;

    initializedGroups.add(group);
    let foundOpenItem = false;
    items.forEach((item) => {
      if (item.open) {
        if (foundOpenItem) item.open = false;
        foundOpenItem = true;
      }

      const summary = item.querySelector(':scope > summary');
      summary?.addEventListener('click', (event) => {
        event.preventDefault();
        const shouldOpen = !item.open;

        if (shouldOpen) {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.open) setItemOpen(otherItem, false);
          });
        }

        setItemOpen(item, shouldOpen);
      });
    });
  }

  function initializeAccordions(root = document) {
    if (root.matches?.(groupSelector)) initializeGroup(root);
    root.querySelectorAll?.(groupSelector).forEach(initializeGroup);
  }

  window.IslanderFaqAccordion = { initialize: initializeAccordions };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAccordions(), { once: true });
  } else {
    initializeAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAccordions(event.target));
})();
